import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ForgotPasswordData {
  accountId: number
  message: string
  maskedEmail: string
  forgotUserIdChecked: boolean
  forgotPasswordChecked: boolean
}

const initialState: ForgotPasswordData = {
  accountId: 0,
  message: '',
  maskedEmail: '',
  forgotUserIdChecked: false,
  forgotPasswordChecked: false
}

export function getEmptyForgotPasswordData(): ForgotPasswordData {
  const forgotPasswordData: ForgotPasswordData = {
    accountId: 0,
    message: '',
    maskedEmail: '',
    forgotUserIdChecked: false,
    forgotPasswordChecked: false
  }
  return forgotPasswordData
}

const forgotPasswordData = createSlice({
  name: 'forgotPasswordData',
  initialState: initialState,
  reducers: {
    setForgotPasswordData(
      state,
      { payload }: PayloadAction<ForgotPasswordData>
    ) {
      return payload
    }
  }
})

export const { setForgotPasswordData } = forgotPasswordData.actions

export default forgotPasswordData.reducer
